import PropTypes from 'prop-types';

const programShape = {
  uuid: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  stripedSubtitle: PropTypes.string,
  status: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  primarySubject: PropTypes.shape({
    name: PropTypes.string,
    slug: PropTypes.string,
    numberOfCourses: PropTypes.number,
  }),
  subjects: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  })).isRequired,
  hook: PropTypes.string,
  marketingUrl: PropTypes.string.isRequired,
  courses: PropTypes.arrayOf(PropTypes.shape({
    course: PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string,
      activeCourseRun: PropTypes.shape({
        key: PropTypes.string.isRequired,
        uuid: PropTypes.string.isRequired,
        marketingPath: PropTypes.string.isRequired,
        minEffort: PropTypes.number.isRequired,
        maxEffort: PropTypes.number.isRequired,
        weeksToComplete: PropTypes.number.isRequired,
      }),
    }),
  })),
  authoringOrganizations: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
  })).isRequired,
  isProgramEligibleForOneClickPurchase: PropTypes.bool,
};

export default programShape;
